import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Map, Building2, ArrowRight, Sparkles } from "lucide-react";
export default function BeginYourExperience() {
  return <section data-section-id="235495" id="emergency-assistance-now" className="relative w-full overflow-hidden dark bg-background py-24 lg:py-32">
      {}
      <style>{`
        @keyframes float-breathe {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
          100% { transform: translateY(0px); }
        }
        .animate-float-breathe {
          animation: float-breathe 6s ease-in-out infinite;
        }
      `}</style>

      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--color-primary)_0%,_transparent_60%)] opacity-20 pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16 lg:mb-24">
          <div className="inline-flex items-center justify-center p-2 bg-primary rounded-full mb-4">
            <Sparkles className="w-5 h-5 text-primary-foreground mr-2" />
            <span className="text-sm font-bold text-primary-foreground uppercase tracking-widest">
              Emergency Response 24/7
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default text-foreground mb-6 uppercase tracking-tighter">
            Stuck in Leeds? Call Now
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg md:text-xl font-default">
            Don't let a flat tyre ruin your day. Our mobile fitting units are stationed across Leeds ready to reach you in 30-60 minutes.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-8 items-center">
          {}
          <div className="flex flex-col items-center lg:items-end text-center lg:text-right space-y-6 order-2 lg:order-1">
            <div className="p-5 bg-primary/20 rounded-2xl text-primary shadow-lg shadow-primary/20">
              <Map className="w-10 h-10" />
            </div>
            <div className="max-w-sm">
              <h3 className="text-2xl md:text-3xl font-bold font-default text-foreground mb-4 uppercase">
                Rapid Callouts
              </h3>
              <p className="text-muted-foreground mb-8 leading-relaxed font-default">
                Emergency tyre fitting Leeds. We cover Headingley, Roundhay, Pudsey, and beyond with lightning-fast response times.
              </p>
              <Button asChild size="lg" className="w-full sm:w-auto rounded-full px-8 bg-primary text-primary-foreground hover:bg-primary/90 shadow-xl shadow-primary/30">
                <Link to="#">
                  View All Services <ArrowRight className="ml-2 w-5 h-5" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative flex justify-center items-center order-1 lg:order-2 py-8 lg:py-0">
            {}
            <div className="absolute inset-0 bg-primary/30 blur-[80px] rounded-full transform scale-75" />
            
            {}
            <div className="relative z-10 w-full max-w-[260px] md:max-w-[300px] aspect-[9/19] bg-card rounded-4xl border-[6px] border-border shadow-4xl overflow-hidden animate-float-breathe">
              {}
              <div className="absolute top-0 inset-x-0 h-6 bg-border rounded-b-xl w-1/2 mx-auto z-20" />
              
              {}
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647150/img/leeds_mobile_tyre_van_dispatch.png" alt="Emergency Tyre Fitting Leeds Dispatch" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500" />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-tr from-black/40 to-transparent pointer-events-none" />
            </div>
          </div>

          {}
          <div className="flex flex-col items-center lg:items-start text-center lg:text-left space-y-6 order-3">
            <div className="p-5 bg-accent/10 rounded-2xl text-primary shadow-lg">
              <Building2 className="w-10 h-10" />
            </div>
            <div className="max-w-sm">
              <h3 className="text-2xl md:text-3xl font-bold font-default text-foreground mb-4 uppercase">
                Local Experts
              </h3>
              <p className="text-muted-foreground mb-8 leading-relaxed font-default">
                Professional mobile tyre repair Leeds. Our certified technicians bring the garage to your doorstep or roadside location.
              </p>
              <Button asChild size="lg" className="w-full sm:w-auto rounded-full px-8 bg-foreground text-background hover:bg-foreground/90 shadow-xl">
                <Link to="#">
                  Call 0113 000 0000 <ArrowRight className="ml-2 w-5 h-5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}